import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { toggle } from './slice'

import { CustomDrawer, CustomDrawerHeader } from './styled'

import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'

import CampaignIcon from '@mui/icons-material/Campaign'
import DashboardIcon from '@mui/icons-material/Dashboard'
import PeopleIcon from '@mui/icons-material/People'
import BusinessIcon from '@mui/icons-material/Business'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import Diversity1Icon from '@mui/icons-material/Diversity1'
import ViewColumnIcon from '@mui/icons-material/ViewColumn'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'

import { ROUTES } from '../../constants/routes'

const AppMenu = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isOpen } = useSelector((state) => state.persisted.appMenu)

  const handleDrawerToogle = () => {
    dispatch(toggle())
  }

  const menuItems = [
    {
      id: 'dashboard',
      text: 'Dashboard',
      icon: <DashboardIcon />,
      onClick: () => {
        navigate(ROUTES.DASHBOARD, { replace: true })
      },
    },
    {
      id: 'clients',
      text: 'Clients',
      icon: <Diversity1Icon />,
      onClick: () => {
        navigate(ROUTES.CLIENTS, { replace: true })
      },
    },
    {
      id: 'campaigns',
      text: 'Campaigns',
      icon: <CampaignIcon />,
      onClick: () => {
        navigate(ROUTES.CAMPAIGNS, { replace: true })
      },
    },
    {
      id: 'prospects',
      text: 'Prospects',
      icon: <BusinessIcon />,
      onClick: () => {
        navigate(ROUTES.PROSPECTS, { replace: true })
      },
    },
    {
      id: 'fields',
      text: 'Fields',
      icon: <ViewColumnIcon />,
      onClick: () => {
        navigate(ROUTES.FIELDS, { replace: true })
      },
    },
    {
      id: 'dispositions',
      text: 'Dispositions',
      icon: <CheckCircleOutlineIcon />,
      onClick: () => {
        navigate(ROUTES.DISPOSITIONS, { replace: true })
      },
    },
    {
      id: 'users',
      text: 'Users',
      icon: <PeopleIcon />,
      onClick: () => {
        navigate(ROUTES.USERS, { replace: true })
      },
    },
  ]

  return (
    <CustomDrawer variant="permanent" open={isOpen}>
      <CustomDrawerHeader />
      <List sx={{ paddingTop: 0, paddingBottom: 0 }}>
        <ListItem key="hide" disablePadding sx={{ display: 'block' }}>
          <ListItemButton
            key="drawerToogle"
            onClick={handleDrawerToogle}
            sx={{ minHeight: 48, justifyContent: isOpen ? 'initial' : 'center', px: 2.5 }}
          >
            <ListItemIcon sx={{ minWidth: 0, mr: isOpen ? 3 : 'auto', justifyContent: 'center' }}>
              {isOpen ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List sx={{ paddingTop: 0, paddingBottom: 0 }}>
        {menuItems.map((item) => (
          <ListItem key={item.id} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              sx={{ minHeight: 48, justifyContent: isOpen ? 'initial' : 'center', px: 2.5 }}
              onClick={item.onClick}
            >
              <ListItemIcon sx={{ minWidth: 0, mr: isOpen ? 3 : 'auto', justifyContent: 'center' }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} sx={{ opacity: isOpen ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </CustomDrawer>
  )
}

export default AppMenu
